module.exports = __webpack_public_path__ + "media/flame.1eae46f7.wav";